import { useCallback, useEffect } from 'react';
import { AppLoader } from 'shared';

const RedirectUrl = ({ url }) => {
  const redirect = useCallback(() => {
    window.location.href = url;
  }, [url]);

  useEffect(() => {
    redirect();
  }, [redirect]);

  return <AppLoader />;
};

export default RedirectUrl;
